module.exports = __webpack_public_path__ + "static/img/increase.8fa6be0b.svg";